import { FC } from 'react'
import './confirmation.css'

// COMPONENTS
import * as Icons from '@icons'
import { Column } from '@components/templates/column'
import GroupBanner from '@components/organisims/group-banner'
import Button from '@components/atoms/button'

// TYPES
import type { RouteObject } from 'react-router-dom'

// UTILITIES
import { getGroupStatus } from '@utils/temp-helpers'
import { useGroupLoaderData } from '..'

interface Props { }

const GroupConfirmationScreen: FC<Props> = () => {
    const group = useGroupLoaderData()
    const { groupStatus } = getGroupStatus(group)

    return (<>
        <Column.Content className='group-banner-section'>
            <GroupBanner group={group} groupStatus={groupStatus} />
        </Column.Content>
        <Column.Content className="group-confirmation-screen">
            <div className="confirmation-container">
                <Icons.Check type="bordered" height="6rem" width="6rem" style={{ color: 'var(--splitcard-green-500)' }} />
                <h2 style={{ lineHeight: 1 }}>You Have Successfully Joined The Group!</h2>
                <p className='text-body'>
                    You will receive text notifications about group activity and when your credit
                    card is charged.
                </p>
            </div>
            <Column.Footer>
                <Button type="submit" to={`/group/${group.id}`}>Done</Button>
            </Column.Footer>
        </Column.Content>
    </>)
}

const ConfirmationRoute: RouteObject = {
    path: "confirmation",
    element: <GroupConfirmationScreen />,
}

export default ConfirmationRoute
